import React from 'react';

const IconMessage = props => {
  const { className } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path fill='none' d="M5.23471 13.344V10.7041H3.41157C3.16981 10.7041 2.93795 10.6081 2.76699 10.4371C2.59604 10.2662 2.5 10.0343 2.5 9.79256V3.41157C2.5 3.16981 2.59604 2.93795 2.76699 2.76699C2.93795 2.59604 3.16981 2.5 3.41157 2.5H13.4388C13.6806 2.5 13.9125 2.59604 14.0834 2.76699C14.2544 2.93795 14.3504 3.16981 14.3504 3.41157V9.79256C14.3504 10.0343 14.2544 10.2662 14.0834 10.4371C13.9125 10.6081 13.6806 10.7041 13.4388 10.7041H8.42521L5.62395 13.5054C5.59208 13.5373 5.55144 13.5591 5.50718 13.5679C5.46291 13.5768 5.41703 13.5723 5.37534 13.555C5.33365 13.5377 5.29802 13.5084 5.27299 13.4709C5.24795 13.4333 5.23463 13.3892 5.23471 13.344Z" stroke="#242424"/>
      <path d="M5.23438 7.96945H11.6154M5.23438 5.23474H11.6154" stroke="#242424" strokeLinecap="round"/>
    </svg>
  );
};

export default IconMessage;
